import { authHeader } from '@/_helpers';
export const calendlyService = {
    getEvent,
    getCalendars,
    getAllEvents,
    nextPage
};

const apiUrl = process.env.VUE_APP_ROOT_API;


function getEvent(id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ id })
    };
    return fetch(`${apiUrl}/calendly/event`, requestOptions).then(handleResponse);
}

function getAllEvents(calendly,quantity) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({calendly,quantity})
    };
    return fetch(`${apiUrl}/calendly/events`, requestOptions).then(handleResponse);
}

function nextPage(url,calendly) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({url,calendly})
    };
    return fetch(`${apiUrl}/calendly/nextpage`, requestOptions).then(handleResponse);
}

function getCalendars() {
     const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/calendly/calendars`, requestOptions).then(handleResponse);
}


function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = data || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}